import React, { useEffect, useRef, useState } from 'react';
import inspectionStorage from '../services/inspectionStorage';
import apiService from '../services/apiService';

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #fee2e2, #fecaca)',
    paddingBottom: '100px'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px',
    background: 'linear-gradient(135deg, #dc2626, #b91c1c)',
    color: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 100
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: '700',
    margin: 0
  },
  backBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  content: {
    padding: '16px'
  },
  card: {
    background: 'white',
    borderRadius: '12px',
    padding: '16px',
    marginBottom: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
  },
  cardTitle: {
    fontSize: '14px',
    fontWeight: '700',
    color: '#991b1b',
    marginBottom: '8px'
  },
  badge: {
    display: 'inline-block',
    padding: '4px 8px',
    borderRadius: '8px',
    background: '#fee2e2',
    color: '#991b1b',
    fontSize: '11px',
    fontWeight: '700'
  },
  button: {
    padding: '8px 12px',
    background: '#dc2626',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '700'
  },
  buttonOutline: {
    padding: '8px 12px',
    background: 'white',
    color: '#991b1b',
    border: '2px solid #dc2626',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '700'
  },
  item: {
    padding: '10px',
    borderRadius: '10px',
    border: '1px solid #e5e7eb',
    marginTop: '8px'
  },
  itemTitle: {
    fontSize: '13px',
    fontWeight: '700',
    color: '#1f2937'
  },
  itemMeta: {
    fontSize: '12px',
    color: '#6b7280'
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.6)',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    zIndex: 3000
  },
  modal: {
    background: 'white',
    borderRadius: '20px 20px 0 0',
    width: '100%',
    maxHeight: '90vh',
    display: 'flex',
    flexDirection: 'column'
  },
  modalHeader: {
    padding: '16px',
    borderBottom: '1px solid #f3f4f6',
    fontWeight: '700',
    color: '#991b1b',
    background: 'linear-gradient(135deg, #fff1f2, #fee2e2)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  modalTitle: {
    fontSize: '15px',
    fontWeight: '700',
    margin: 0
  },
  modalSubtitle: {
    fontSize: '12px',
    color: '#991b1b',
    marginTop: '4px'
  },
  modalClose: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    border: 'none',
    background: 'white',
    fontSize: '18px',
    cursor: 'pointer',
    boxShadow: '0 2px 6px rgba(0,0,0,0.08)'
  },
  modalBody: {
    padding: '16px',
    overflow: 'auto'
  },
  modalFooter: {
    padding: '16px',
    borderTop: '1px solid #f3f4f6',
    display: 'flex',
    gap: '10px'
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '2px solid #e5e7eb',
    borderRadius: '10px',
    background: '#f9fafb',
    color: '#111827',
    boxSizing: 'border-box',
    marginBottom: '10px'
  },
  formLabel: {
    display: 'block',
    fontSize: '12px',
    fontWeight: '600',
    color: '#374151',
    marginBottom: '6px'
  },
  textarea: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '2px solid #e5e7eb',
    borderRadius: '10px',
    background: '#f9fafb',
    color: '#111827',
    boxSizing: 'border-box',
    minHeight: '70px',
    resize: 'vertical',
    marginBottom: '10px'
  },
  select: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '2px solid #e5e7eb',
    borderRadius: '10px',
    background: '#f9fafb',
    color: '#111827',
    boxSizing: 'border-box',
    marginBottom: '10px'
  },
  imagePreview: {
    width: '100%',
    height: '160px',
    objectFit: 'cover',
    borderRadius: '10px',
    border: '1px solid #e5e7eb',
    marginBottom: '10px'
  },
  uploadRow: {
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap',
    marginBottom: '10px'
  },
  uploadButton: {
    padding: '8px 12px',
    background: '#dc2626',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '700'
  },
  uploadButtonDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed'
  },
  uploadHint: {
    fontSize: '11px',
    color: '#6b7280',
    marginBottom: '10px'
  },
  saveSection: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '16px 20px',
    background: 'white',
    boxShadow: '0 -4px 16px rgba(0,0,0,0.1)'
  },
  saveButton: {
    width: '100%',
    padding: '16px',
    background: 'linear-gradient(135deg, #dc2626, #b91c1c)',
    border: 'none',
    borderRadius: '12px',
    color: 'white',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer'
  }
};

export default function Etape3FichesAnomaliesThermoMobile({ mission, onBack, onSave }) {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [q19, setQ19] = useState({});
  const [fiches, setFiches] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const photoInputRef = useRef(null);
  const thermoInputRef = useRef(null);

  const emptyFiche = {
    numero: 0,
    date_heure_image: new Date().toISOString(),
    batiment: '',
    photo_normale_url: '',
    thermogramme_url: '',
    designation_materiel: {
      localisation: '',
      appareillage: '',
      etat_fonctionnement: 'En charge'
    },
    constat: {
      causes_probables: '',
      actions_preconisees: '',
      degre_priorite: null
    }
  };

  const [currentFiche, setCurrentFiche] = useState(emptyFiche);

  useEffect(() => {
    loadData();
  }, [mission.id]);

  const loadData = async () => {
    setLoading(true);
    try {
      const stored = await inspectionStorage.getStep(mission.id, 'rapport_q19_data');
      const base = stored || {};
      setQ19(base);
      setFiches(base.fiches_anomalies || []);
    } catch (error) {
      console.error('❌ Erreur chargement fiches:', error);
    } finally {
      setLoading(false);
    }
  };

  const computePriorities = (list) => ({
    anomalies_priority_1: list.filter(f => f.constat?.degre_priorite === 1).length,
    anomalies_priority_2: list.filter(f => f.constat?.degre_priorite === 2).length,
    anomalies_priority_3: list.filter(f => f.constat?.degre_priorite === 3).length
  });

  const syncEquipements = (ficheData, list, removing = false) => {
    const equipements = (q19.equipements_controles || []).map(g => ({ ...g }));
    const localisation = ficheData.designation_materiel?.localisation;
    const batiment = ficheData.batiment;
    const appareillage = ficheData.designation_materiel?.appareillage;
    if (!localisation || !batiment || !appareillage) {
      return equipements;
    }

    let groupe = equipements.find(g => g.groupe_localisation === localisation);
    if (!groupe) {
      if (removing) return equipements;
      groupe = { groupe_localisation: localisation, sous_categories: [] };
      equipements.push(groupe);
    }
    let categorie = groupe.sous_categories.find(c => c.nom === batiment);
    if (!categorie) {
      if (removing) return equipements;
      categorie = { nom: batiment, equipements: [] };
      groupe.sous_categories.push(categorie);
    }
    let equipement = categorie.equipements.find(e => e.nature_designation === appareillage);
    if (!equipement) {
      if (removing) return equipements;
      equipement = { nature_designation: appareillage };
      categorie.equipements.push(equipement);
    }
    if (removing) {
      equipement.defaut_fiche = '';
      equipement.priorite = null;
    } else {
      equipement.defaut_fiche = `F${String(ficheData.numero).padStart(3, '0')}`;
      equipement.priorite = ficheData.constat?.degre_priorite || null;
    }
    return equipements;
  };

  const saveQ19 = async (updatedFiches, overrides = {}) => {
    const stored = await inspectionStorage.getStep(mission.id, 'rapport_q19_data');
    const priorities = computePriorities(updatedFiches);
    const nextQ19 = {
      ...(stored || {}),
      ...q19,
      fiches_anomalies: updatedFiches,
      ...priorities,
      ...overrides
    };
    setQ19(nextQ19);
    setFiches(updatedFiches);
    await inspectionStorage.saveStep(mission.id, 'rapport_q19_data', nextQ19);
  };

  const handleOpenModal = (fiche = null, index = null) => {
    setEditingIndex(index);
    setCurrentFiche(fiche ? { ...fiche } : { ...emptyFiche });
    setShowModal(true);
  };

  const handleSaveFiche = async () => {
    if (!currentFiche.designation_materiel?.appareillage) return;
    const updated = [...fiches];
    let nextNumero = q19.dernier_numero_fiche || 0;
    if (editingIndex !== null) {
      updated[editingIndex] = { ...currentFiche };
    } else {
      nextNumero += 1;
      updated.push({ ...currentFiche, numero: nextNumero });
    }
    const syncedEquipements = syncEquipements({ ...currentFiche, numero: nextNumero }, updated);
    await saveQ19(updated, {
      dernier_numero_fiche: nextNumero,
      equipements_controles: syncedEquipements
    });
    setShowModal(false);
    setEditingIndex(null);
  };

  const handleDeleteFiche = async (index) => {
    const fiche = fiches[index];
    const updated = fiches.filter((_, i) => i !== index);
    const syncedEquipements = syncEquipements(fiche, updated, true);
    await saveQ19(updated, { equipements_controles: syncedEquipements });
  };

  const handlePhotoUpload = async (file, type) => {
    if (!file) return;
    setUploading(true);
    try {
      const result = await apiService.uploadFile(file, 'thermo');
      if (!result.success || !result.file_url) {
        throw new Error(result.error || 'Erreur upload');
      }
      setCurrentFiche(prev => ({
        ...prev,
        photo_normale_url: type === 'photo' ? result.file_url : prev.photo_normale_url,
        thermogramme_url: type === 'thermo' ? result.file_url : prev.thermogramme_url
      }));
    } catch (error) {
      console.error('❌ Erreur upload:', error);
      alert('Erreur upload');
    } finally {
      setUploading(false);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const stored = await inspectionStorage.getStep(mission.id, 'rapport_q19_data');
      await inspectionStorage.saveStep(mission.id, 'rapport_q19_data', {
        ...(stored || {}),
        ...q19,
        fiches_anomalies: fiches
      });
      if (onSave) onSave({ fiches_anomalies: fiches });
      onBack();
    } catch (error) {
      console.error('❌ Erreur sauvegarde:', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#fee2e2' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: '40px', height: '40px', border: '4px solid #e5e7eb', borderTopColor: '#dc2626', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto' }}></div>
          <p style={{ marginTop: '16px', color: '#991b1b', fontWeight: '500' }}>Chargement...</p>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>← Retour</button>
        <h1 style={styles.headerTitle}>Fiches anomalies</h1>
        <button style={styles.backBtn} onClick={handleSave} disabled={saving}>
          {saving ? '⏳' : '💾'}
        </button>
      </div>

      <div style={styles.content}>
        <div style={styles.card}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={styles.cardTitle}>📄 Fiches</div>
            <button style={styles.button} onClick={() => handleOpenModal(null, null)}>+ Nouvelle fiche</button>
          </div>
          <div style={{ marginTop: '8px' }}>
            <span style={styles.badge}>{fiches.length} fiche(s)</span>
          </div>
        </div>

        {fiches.map((fiche, index) => (
          <div key={index} style={styles.card}>
            <div style={styles.itemTitle}>F{String(fiche.numero || index + 1).padStart(3, '0')} - {fiche.designation_materiel?.appareillage || 'Équipement'}</div>
            <div style={styles.itemMeta}>
              {fiche.batiment || 'Bâtiment'} · {fiche.constat?.degre_priorite ? `P${fiche.constat.degre_priorite}` : 'Priorité ?'}
            </div>
            <div style={{ marginTop: '8px', display: 'flex', gap: '8px' }}>
              <button style={styles.buttonOutline} onClick={() => handleOpenModal(fiche, index)}>Modifier</button>
              <button style={{ ...styles.buttonOutline, borderColor: '#ef4444', color: '#b91c1c' }} onClick={() => handleDeleteFiche(index)}>Supprimer</button>
            </div>
          </div>
        ))}
      </div>

      <div style={styles.saveSection}>
        <button style={{ ...styles.saveButton, ...(saving ? { opacity: 0.6, cursor: 'not-allowed' } : {}) }} onClick={handleSave} disabled={saving}>
          {saving ? '⏳ Sauvegarde...' : '💾 Sauvegarder'}
        </button>
      </div>

      {showModal && (
        <div style={styles.overlay} onClick={() => setShowModal(false)}>
          <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <div>
                <div style={styles.modalTitle}>Fiche d’anomalie</div>
                <div style={styles.modalSubtitle}>Photo normale + thermogramme</div>
              </div>
              <button style={styles.modalClose} onClick={() => setShowModal(false)}>✕</button>
            </div>
            <div style={styles.modalBody}>
              <label style={styles.formLabel}>Localisation</label>
              <input style={styles.input} placeholder="Ex: Atelier A" value={currentFiche.designation_materiel?.localisation || ''} onChange={(e) => setCurrentFiche(prev => ({ ...prev, designation_materiel: { ...prev.designation_materiel, localisation: e.target.value } }))} />
              <label style={styles.formLabel}>Bâtiment / Zone</label>
              <input style={styles.input} placeholder="Ex: TGBT" value={currentFiche.batiment || ''} onChange={(e) => setCurrentFiche(prev => ({ ...prev, batiment: e.target.value }))} />
              <label style={styles.formLabel}>Appareillage</label>
              <input style={styles.input} placeholder="Ex: Disjoncteur général" value={currentFiche.designation_materiel?.appareillage || ''} onChange={(e) => setCurrentFiche(prev => ({ ...prev, designation_materiel: { ...prev.designation_materiel, appareillage: e.target.value } }))} />
              <label style={styles.formLabel}>État de fonctionnement</label>
              <select style={styles.select} value={currentFiche.designation_materiel?.etat_fonctionnement || 'En charge'} onChange={(e) => setCurrentFiche(prev => ({ ...prev, designation_materiel: { ...prev.designation_materiel, etat_fonctionnement: e.target.value } }))}>
                <option value="En charge">En charge</option>
                <option value="Charge partielle">Charge partielle</option>
                <option value="A vide">À vide</option>
              </select>
              <label style={styles.formLabel}>Priorité</label>
              <select style={styles.select} value={currentFiche.constat?.degre_priorite || ''} onChange={(e) => setCurrentFiche(prev => ({ ...prev, constat: { ...prev.constat, degre_priorite: e.target.value ? Number(e.target.value) : null } }))}>
                <option value="">Priorité</option>
                <option value="1">Priorité 1</option>
                <option value="2">Priorité 2</option>
                <option value="3">Priorité 3</option>
              </select>
              <label style={styles.formLabel}>Causes probables</label>
              <textarea style={styles.textarea} placeholder="Décrivez les causes..." value={currentFiche.constat?.causes_probables || ''} onChange={(e) => setCurrentFiche(prev => ({ ...prev, constat: { ...prev.constat, causes_probables: e.target.value } }))} />
              <label style={styles.formLabel}>Actions préconisées</label>
              <textarea style={styles.textarea} placeholder="Actions recommandées..." value={currentFiche.constat?.actions_preconisees || ''} onChange={(e) => setCurrentFiche(prev => ({ ...prev, constat: { ...prev.constat, actions_preconisees: e.target.value } }))} />

              <div style={styles.uploadHint}>Ajoutez une photo normale et un thermogramme.</div>
              <div style={styles.uploadRow}>
                <button
                  type="button"
                  style={{ ...styles.uploadButton, ...(uploading ? styles.uploadButtonDisabled : {}) }}
                  onClick={() => photoInputRef.current?.click()}
                  disabled={uploading}
                >
                  {uploading ? 'Upload...' : '📷 Photo normale'}
                </button>
                <button
                  type="button"
                  style={{ ...styles.uploadButton, ...(uploading ? styles.uploadButtonDisabled : {}) }}
                  onClick={() => thermoInputRef.current?.click()}
                  disabled={uploading}
                >
                  {uploading ? 'Upload...' : '🌡️ Thermogramme'}
                </button>
              </div>
              {currentFiche.photo_normale_url && <img src={currentFiche.photo_normale_url} alt="Photo" style={styles.imagePreview} />}
              {currentFiche.thermogramme_url && <img src={currentFiche.thermogramme_url} alt="Thermogramme" style={styles.imagePreview} />}
              <input ref={photoInputRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={(e) => { handlePhotoUpload(e.target.files?.[0], 'photo'); e.target.value = ''; }} />
              <input ref={thermoInputRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={(e) => { handlePhotoUpload(e.target.files?.[0], 'thermo'); e.target.value = ''; }} />
            </div>
            <div style={styles.modalFooter}>
              <button style={styles.buttonOutline} onClick={() => setShowModal(false)}>Annuler</button>
              <button style={styles.button} onClick={handleSaveFiche} disabled={uploading}>
                {uploading ? 'Upload...' : 'Enregistrer'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
